import React, { useEffect, useState } from 'react'
import {
    getDeletedCommande
} from '../../../api/commande'
import toast from 'react-hot-toast'
import {
    searchCommandesByClientAndTransporter,
    searchCommandesByDate,
    searchCommandesByPrixMinMax,
    searchCommandesById,
} from '../../../api/search'
import { useSelector } from 'react-redux'
import { FaRegFilePdf } from "react-icons/fa";
import DataTable from 'react-data-table-component'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import { GradientText } from '../../PasserCommande/PasserCommande.styles'
import LayoutAdmin from '../../../Components/LayoutAdmin/LayoutAdmin'
import Modal from 'react-modal'
import Select from 'react-select'
import moment from 'moment'
import { useHistory } from 'react-router'
import DetailCommandeModal from '../../../Components/DetailCommande/DetailCommandeAdminModal'
import { MdOutlineListAlt } from 'react-icons/md'
import { useAuthenticatedFetch } from '../../../hooks'
import { mergeAvoirForCommande ,mergeInvoiceForCommande} from '../../../api/invoice'
Modal.setAppElement('#root')

function CommandesSupprimees() {
    const history = useHistory()
    const [chargementEnCours, setChargementEnCours] = useState(false)
    const [data, setData] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [selected, setSelected] = useState([])
    const [clearSelected, setClearSelected] = useState(false)
    const [searchQueryId, setSearchQueryId] = useState('')
    const [searchCriteria, setSearchCriteria] = useState('id')
    const [range, setRange] = useState([new Date(), new Date()])
    const [searchQuery, setSearchQuery] = useState('')
    const [min, setMin] = useState(0)
    const [max, setMax] = useState(300)
    const type = 'supprimer'
    const token = useSelector((state) => state.auth.token)
    const [modalIsOpenDetail, setModalIsOpenDetail] = useState(false)
    const [selectedCommande, setSelectedCommande] = useState(null)
    const [selectedOption, setSelectedOption] = useState({
        value: 'id',
        label: "Recherche par l'identifiant ",
    })
    const [isSearching, setIsSearching] = useState(false)
    // Ajout des états pour les URLs des fichiers
    const [fileUrls, setFileUrls] = useState({})
    const [fileLoading, setFileLoading] = useState({})
    const {
        fetchResource,
        error: fetchError,
        loading: fetchLoading,
    } = useAuthenticatedFetch()

    const handleChange = (selectedOption) => {
        setSelectedOption(selectedOption)
        setSearchCriteria(selectedOption.value)
    }
    
   const handleViewAvoir = async (id) => {
	try {
		const res=await mergeAvoirForCommande(id,token)
		const fileBlob = await fetchResource(res.mergedPdfPath, token)
			if (fetchError) {
			    toast.error('Impossible de récupérer la facture', {
					style: {fontFamily: 'Montserrat',},})
				console.error('Failed to fetch the facture', fetchError)
			}
		window.open(fileBlob)

	} catch (error) {
		console.log(error)
	}
   };
   const handleViewInvoices = async (id) => {
		try {
			const res=await mergeInvoiceForCommande(id,token)
			const fileBlob = await fetchResource(res.mergedPdfPath, token)
			if (fetchError) {
			    toast.error('Impossible de récupérer la facture', {
					style: {fontFamily: 'Montserrat',},})
				console.error('Failed to fetch the facture', fetchError)
			}
			
			window.open(fileBlob)
		} catch (error) {
			console.log(error)
		}
    };

        // Fonction pour charger les URLs des logos
        const loadLogoUrls = async (commandes) => {
            const urls = {}
            const loadingStates = {}
    
            for (const commande of commandes) {
                if (commande.clientID?.logo?.path) {
                    const clientId = commande.clientID._id
                    loadingStates[clientId] = true
                    
                    try {
                        const url = await fetchResource(commande.clientID.logo.path, token)
                        urls[clientId] = url
                    } catch (error) {
                        console.error(`Error loading logo for client ${clientId}:`, error)
                        // Utiliser l'image par défaut en cas d'erreur
                        urls[clientId] = 'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'
                    } finally {
                        loadingStates[clientId] = false
                    }
                }
            }
    
            setFileUrls(prev => ({ ...prev, ...urls }))
            setFileLoading(prev => ({ ...prev, ...loadingStates }))
        }

    const fetchCommandes = async (page, perPage, isSearching) => {
        setChargementEnCours(true)
        try {
            let res
            if (!isSearching) {
                res = await getDeletedCommande(page, perPage, token)
            } else {
                switch (searchCriteria) {
                    case 'id':
                        if (!searchQueryId.trim()) {
                            toast.error('Veuillez saisir un identifiant', {
                                style: { fontFamily: 'Montserrat' },
                            })
                            return
                        }
                        res = await searchCommandesById(
                            searchQueryId,
                            type,
                            token
                        )
                        break
                    case 'ct':
                        if (!searchQuery.trim()) {
                            toast.error('Veuillez saisir un nom de client', {
                                style: { fontFamily: 'Montserrat' },
                            })
                            return
                        }
                        res = await searchCommandesByClientAndTransporter(
                            searchQuery,
                            type,
                            token,
                            page,
                            perPage
                        )
                        break
                    case 'prix':
                        if (Number(min) > Number(max)) {
                            toast.error(
                                'Le prix minimum doit être inférieur au prix maximum',
                                {
                                    style: { fontFamily: 'Montserrat' },
                                }
                            )
                            return
                        }
                        res = await searchCommandesByPrixMinMax(
                            min,
                            max,
                            type,
                            token,
                            page,
                            perPage
                        )
                        break
                    case 'date':
                        if (!range || !range[0] || !range[1]) {
                            toast.error(
                                'Veuillez sélectionner une plage de dates',
                                {
                                    style: { fontFamily: 'Montserrat' },
                                }
                            )
                            return
                        }
                        const minDate = moment(range[0]).format()
                        const maxDate = moment(range[1]).format()
                        const offsetUTC = moment().format('Z')
                        res = await searchCommandesByDate(
                            minDate,
                            maxDate,
                            type,
                            token,
                            page,
                            perPage,
                            offsetUTC
                        )
                        break
                    default:
                        return
                }
            }
            const commandes = res?.commandes || []
            setData(commandes)
            setTotalRows(res?.totalCommandes || 0)
            
            // Charger les URLs des logos après avoir récupéré les commandes
            if (commandes.length > 0) {
                await loadLogoUrls(commandes)
            }
        } catch (error) {
            toast.error("Une erreur s'est produite lors de la recherche", {
                style: { fontFamily: 'Montserrat' },
            })
        } finally {
            setChargementEnCours(false)
        }
    }

    const handleSearch = async () => {
        setIsSearching(true)
        setCurrentPage(1)
        await fetchCommandes(1, perPage, true)
    }
    const handleClear = async () => {
        setSelectedOption({
            value: 'id',
            label: "Recherche par l'identifiant ",
        })
        setSearchCriteria('id')
        setSearchQuery('')
        setSearchQueryId('')
        setMin(0)
        setMax(300)
        setRange([new Date(), new Date()])
        setIsSearching(false)
        setCurrentPage(1)

        await fetchCommandes(1, perPage, false)
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        fetchCommandes(page, perPage, isSearching)
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCommandes(page, newPerPage, isSearching)
        setPerPage(newPerPage)
    }

   
    const handleSelectedRowsChange = (state) => {
        setSelected(state.selectedRows)
        setClearSelected(false)
    }
    
    useEffect(() => {
        fetchCommandes(currentPage, perPage, isSearching)
    }, [])

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.__id,
            width: '110px',
            sortable: false,
        },
        {
            name: 'Type du transport',
            selector: (row) => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <span
                        style={{
                            fontWeight: 'bold',
                            color: '#51C7F2',
                            marginBottom: 3,
                        }}
                    >
                        {row.type_commande == 'course-a-course'
                            ? 'Course à course'
                            : 'Mise à disposition'}
                    </span>
                </div>
            ),
            width: '150px',
            sortable: false,
        },
        {
            name: 'Etapes ',
            selector: (row) => {
                if (row.type_commande === 'course-a-course') {
                    return (
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <span>{row.courses.length}</span>
                        </div>
                    )
                } else {
                    return (
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <span>{row.missions.length}</span>
                        </div>
                    )
                }
            },
            sortable: false,
            width: '100px',
        },
        {
            name: 'Montant',
            selector: (row) => {
                const totalForfait = row.packages || []
                const totalPackagePrice = totalForfait.reduce(
                    (total, p) => total + p.price,
                    0
                )

                const montantTotal = row.prix + totalPackagePrice
                const montantAvecMargin = (
                    montantTotal -
                    (montantTotal * (row.margin ?? 0)) / 100
                ).toFixed(2)

                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span>{montantTotal.toFixed(2)}€</span>
                        <span>{montantAvecMargin}€</span>
                    </div>
                )
            },
            width: '110px',
            sortable: false,
        },
        {
           name: 'Prix remboursé',
           selector: (row) => row.prixRembourse ? `${row.prixRembourse} €` : '—',
           width: '150px',
          sortable: false,
         },
        {
            name: 'Client',
            cell: (row) => {
                const clientId = row.clientID?._id
                const isLoading = fileLoading[clientId]
                const logoUrl = fileUrls[clientId]
                
                return (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={() => {
                            if (row.clientID?.deletedAt !== null) {
                                history.push(
                                    `/admin/clients/single/${row.clientID._id}`
                                )
                            } else {
                                history.push(`/admin/clients/${row.clientID._id}`)
                            }
                        }}
                    >
                        {isLoading ? (
                            <div 
                                style={{
                                    width: '2rem',
                                    height: '2rem',
                                    borderRadius: '1rem',
                                    marginRight: 10,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f0f0f0'
                                }}
                            >
                                <div className='customLoader' style={{ transform: 'scale(0.3)' }}></div>
                            </div>
                        ) : (
                            <img
                                style={{
                                    width: '2rem',
                                    height: '2rem',
                                    borderRadius: '1rem',
                                    marginRight: 10,
                                    objectFit: 'cover'
                                }}
                                src={
                                    logoUrl || 
                                    'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'
                                }
                                alt='Logo client'
                                onError={(e) => {
                                    e.target.src = 'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'
                                }}
                            />
                        )}
                        <span
                            style={{
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                color:
                                    row?.clientID?.deletedAt !== null
                                        ? 'red'
                                        : '#51C7F2',
                            }}
                        >
                            {row?.clientID?.societe}
                        </span>
                    </div>
                )
            },
            sortable: false,
            width: '150px',
        },
        {
            name: 'Statut du payment',
            selector: (row) => row.paymentStatus,
            width: '150px',
            sortable: false,
        },
        {
           name: 'Statut remboursement',
           selector: (row) => row.statut_remboursement || '—',
           width: '180px',
           sortable: false,
       },
        {
            name: 'Date de création',
            selector: (row) => moment(row.createdAt).format('DD/MM/YYYY'),
            width: '150px',
            sortable: false,
        },
        {
            name: 'Date de suppression',
            selector: (row) => row.deletedAt ? moment(row.deletedAt).format('DD/MM/YYYY') : '—',
            width: '170px',
            sortable: false,
        },
        {
          name: 'Date de remboursement / échec',
          selector: (row) => {
          if (row.statut_remboursement === 'remboursé' && row.date_remboursement) {
          return moment(row.date_remboursement).format('DD/MM/YYYY');
         }
         if (row.statut_remboursement === 'échoué' && row.date_echec_remboursement) {
         return moment(row.date_echec).format('DD/MM/YYYY');
         }
         return '—';
        },
          width: '170px',
          sortable: false,
        },

        {
            name: 'Missions',
            cell: (row) => (
                <button
                    onClick={() =>
                        history.push(
                            `/admin/commandes/${row._id}/missions?from=commandes`
                        )
                    }
                    style={{
                        padding: '0.5rem 1rem',
                        background: '#51C7F2',
                        border: 'none',
                        borderRadius: '5px',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        fontFamily: 'Montserrat',
                    }}
                >
                    <MdOutlineListAlt size={18} />
                    Voir missions
                </button>
            ),
            width: '180px',
            sortable: false,
        },
        {
            name: 'Actions',
            button: true,
            cell: (row) => (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    <div
                        onClick={() => {
                            setSelectedCommande(row?._id)
                            setModalIsOpenDetail(true)
                        }}
                        style={{
                            cursor: 'pointer',
                        }}
                    >
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='26'
                            height='26'
                            viewBox='0 0 24 24'
                        >
                            <path
                                fill='#b4b4c3'
                                d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z'
                            />
                            <path
                                fill='#b4b4c3'
                                d='M11 7h2v7h-2zm0 8h2v2h-2z'
                            />
                        </svg>
                    </div>

                    <div style={{ width: 10 }} />
                      { row.statut_remboursement==="remboursé" &&
                        <div
                                            
                                            onClick={() => handleViewInvoices(row)}
                                            style={{
                                                cursor: 'pointer',
                                            }}
                                        >
                                        <FaRegFilePdf style={{ fontSize: "25px" ,color:'#51C7F2'}} />
                    
                    
                                        </div>
                      }  
                  { row.statut_remboursement==="remboursé" &&
                   <div
                                        
                                        onClick={() => handleViewAvoir(row._id)}
                                        style={{
                                            cursor: 'pointer',
                                            marginLeft:'2px'
                                        }}
                                    >
                                       <FaRegFilePdf style={{ fontSize: "25px" ,color:'red'}} />
                   
                   
                  </div>
                  }
                </div>
            ),
        },
    ]

    return (
        <LayoutAdmin>
            <div
                style={{
                    //height: '80vh',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: '2rem',
                    paddingBottom: '4rem',
                    fontFamily: 'Montserrat',
                }}
            >
                <GradientText marginTop={'0'}>
                {'commandes supprimées'.toUpperCase()}
                </GradientText>

                <div
                    style={{
                        width: '100%',
                        fontFamily: 'Montserrat',
                        paddingLeft: '1rem',
                        paddingRight: '1rem',
                        marginBottom: '2rem',
                        marginTop: '1rem',
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                >
                    <div
                        style={{
                            width: '350px',
                            fontFamily: 'Montserrat',
                            // paddingLeft: '1rem',
                            // paddingRight: '1rem',
                            // marginBottom: '2rem',
                            // marginTop: '1rem',
                            marginRight: '1rem',
                        }}
                    >
                        <Select
                            isSearchable={false}
                            options={[
                                {
                                    value: 'id',
                                    label: "Recherche par l'identifiant ",
                                },
                                {
                                    value: 'ct',
                                    label: 'Nom Client',
                                },
                                { value: 'prix', label: 'Prix' },
                                { value: 'date', label: 'Date du Transports' },
                            ]}
                            styles={{
                                option: (provided, state) => ({
                                    ...provided,
                                    fontFamily: 'Montserrat',
                                }),
                                control: (provided, state) => ({
                                    ...provided,
                                    height: '3rem',
                                    minHeight: 'fit-content',
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    maxHeight: '3rem',
                                }),
                            }}
                            value={selectedOption}
                            onChange={handleChange}
                            menuPortalTarget={document.querySelector('body')}
                        />
                    </div>
                    {searchCriteria === 'id' ? (
                        <input
                            style={{
                                padding: '0.4rem',
                                borderRadius: 5,
                                border: '1px solid #E4EAF0',
                                height: '3rem',
                                width: '20rem',
                                fontFamily: 'Montserrat',
                            }}
                            value={searchQueryId}
                            onChange={(e) => setSearchQueryId(e.target.value)}
                            placeholder='Recherche'
                        />
                    ) : null}
                    {searchCriteria === 'ct' ? (
                        <input
                            style={{
                                padding: '0.4rem',
                                borderRadius: 5,
                                border: '1px solid #E4EAF0',
                                height: '3rem',
                                width: '20rem',
                                fontFamily: 'Montserrat',
                            }}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder='Recherche'
                        />
                    ) : null}

                    {searchCriteria === 'prix' ? (
                        <>
                            <input
                                type='number'
                                style={{
                                    padding: '0.4rem',
                                    borderRadius: 5,
                                    border: '1px solid #E4EAF0',
                                    height: '3rem',
                                    width: '20rem',
                                    fontFamily: 'Montserrat',
                                    marginRight: '1rem',
                                }}
                                value={min}
                                onChange={(e) => {
                                    setMin(Number(e.target.value))
                                }}
                                placeholder='Prix min'
                            />
                            <input
                                type='number'
                                style={{
                                    padding: '0.4rem',
                                    borderRadius: 5,
                                    border: '1px solid #E4EAF0',
                                    height: '3rem',
                                    width: '20rem',
                                    fontFamily: 'Montserrat',
                                }}
                                value={max}
                                onChange={(e) => {
                                    setMax(Number(e.target.value))
                                }}
                                placeholder='Prix max'
                            />
                        </>
                    ) : null}

                    {searchCriteria === 'date' ? (
                        <DateRangePicker onChange={setRange} value={range} />
                    ) : null}

                    <button
                        onClick={handleSearch}
                        style={{
                            padding: '0.6rem 1rem',
                            height: '3rem',
                            background: '#C9D5F7',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#1C63C5',
                            borderRadius: 7,
                            //marginTop: 20,
                            marginLeft: '1rem',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                        }}
                    >
                        Rechercher
                    </button>

                    <button
                        onClick={handleClear}
                        style={{
                            padding: '0.6rem 1rem',
                            height: '3rem',
                            background: '#C9D5F7',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#1C63C5',
                            borderRadius: 7,
                            //marginTop: 20,
                            marginLeft: '1rem',
                            fontFamily: 'Montserrat',
                            fontWeight: 'bold',
                        }}
                    >
                        Effacer
                    </button>

                   
                  
                    
                </div>
                <div
                    style={{
                        width: '100%',
                        padding: '0 1rem',
                    }}
                >
                    <DataTable
                        columns={columns}
                        data={data}
                        progressPending={chargementEnCours}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                        selectableRows
                        clearSelectedRows={clearSelected}
                        onSelectedRowsChange={handleSelectedRowsChange}
                        noDataComponent="Il n'y a pas des commandes à afficher"
                        progressComponent={
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: 'white',
                                    marginTop: '10rem',
                                }}
                            >
                                <div className='customLoader'></div>
                            </div>
                        }
                        paginationComponentOptions={{
                            rowsPerPageText: 'Rangs par page',
                            rangeSeparatorText: 'sur',
                        }}
                    />
                </div>
            </div>
            <DetailCommandeModal
                isOpen={modalIsOpenDetail}
                onClose={() => setModalIsOpenDetail(false)}
                commandeId={selectedCommande}
            />
         

           
          
        </LayoutAdmin>
    )
}

export default CommandesSupprimees
